import {
  type ComponentPropsWithRef,
  type ElementType,
  type ReactNode,
} from 'react';

import {
  layoutVariants,
  type PolymorphicLayoutProps,
} from './tokens/layout-variants';

type RowComponent = {
  <T extends ElementType = 'div'>(
    props: PolymorphicLayoutProps<T> & {
      ref?: ComponentPropsWithRef<T>['ref'];
    },
  ): ReactNode;
  displayName?: string;
};

export const Row: RowComponent = <T extends ElementType = 'div'>({
  as,
  align,
  justify,
  gap,
  wrap,
  p,
  px,
  py,
  pt,
  pr,
  pb,
  pl,
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml,
  grow,
  shrink,
  basis,
  width,
  height,
  className,
  ref,
  ...props
}: PolymorphicLayoutProps<T> & { ref?: ComponentPropsWithRef<T>['ref'] }) => {
  const Component = as || 'div';

  return (
    <Component
      ref={ref}
      data-slot="row"
      className={layoutVariants({
        align,
        justify,
        gap,
        wrap,
        p,
        px,
        py,
        pt,
        pr,
        pb,
        pl,
        m,
        mx,
        my,
        mt,
        mr,
        mb,
        ml,
        grow,
        shrink,
        basis,
        width,
        height,
        class: ['flex flex-row', className],
      })}
      {...props}
    />
  );
};

Row.displayName = 'Row';
